// extracted by mini-css-extract-plugin
export var askAiIcon = "_m4-9";
export var container = "_m4-0";
export var groupSeparator = "_m4-a";
export var highlight = "_m4-4";
export var resultIcon = "_m4-5";
export var resultItem = "_m4-7";
export var resultSubtitle = "_m4-3";
export var resultTitle = "_m4-2";
export var resultsList = "_m4-1";
export var searchGroup = "_m4-6";
export var selected = "_m4-8";